<template>
  <div class="text-xl font-sans font-medium py-24 px-8 relative min-h-screen green-bkg">
    <!--Introduzione-->
  
      <p v-show="step === 1">
        {{ $t("You're not always a direct person. You could beat around the bush.") }}<br>
        {{ $t('Asking may embarrass you and, for this reason, you may find yourself doing the things that others should have done, having difficulty delegating, and then feeling frustrated.') }}

        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </p>

      <div v-show="step === 2">
        <p>{{ $t('Two activities could help you:') }}</p>

      <div class="flex flex-col mt-4">
        <button  
        @click="step = 3"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
        :class="{ done : active_el == 1 }">{{ $t('Renunciatory behaviors') }}</button>
        
        <button
        v-if="active_el == 1"
        @click="step = 14"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow">{{ $t('Courage') }}</button>

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow opacity-40">{{ $t('Courage') }}</button>

      </div>
      <!-- <span>Clicca su uno dei tasti per approfondire.</span> -->
      
      </div>
  

    <!-- comportamenti rinunciatari-->

      <div v-show="step === 3">
        <p>{{ $t('Remember a time when:') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 4">
        <p>{{ $t("You've been beating the bush instead of going straight to the point") }}</p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer1 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer1 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 5">
        <p>
          {{ $t('You explained the reason for your position instead of simply expressing it as a fact') }}
        </p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer2 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
          {{ $t('Yes') }}

          </button>
          <button
            @click="step++, answer2 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 6">
        <p>{{ $t('You disguised what you really felt') }}</p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer3 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
          {{ $t('Yes') }}

          </button>
          <button
            @click="step++, answer3 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 7">
        <p>{{ $t('You postponed dealing with a problem') }}</p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer5 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
          {{ $t('Yes') }}

          </button>
          <button
            @click="step++, answer5 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 8">
        <p>
          {{ $t('You minimized a problem or situation that was important to you instead') }}
        </p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer6 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
          {{ $t('Yes') }}

          </button>
          <button
            @click="step++, answer6 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 9">
        <p>
         {{ $t('You preferred to send an email instead of talking face to face with the person') }}
        </p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer7 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
          {{ $t('Yes') }}

          </button>
          <button
            @click="step++, answer7 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 10">
        <p>
         {{ $t('You expected the other person to understand without you saying what you wanted') }}
        </p>
        <div class="flex flex-col mt-4">
          <button
            @click="step++, answer8 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
          {{ $t('Yes') }}

          </button>
          <button
            @click="step++, answer8 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 11">
        <p>
          {{ $t("Even if you think these behaviors make your life easier, they don't actually help you:") }}
        </p>

        <div class="p-8 text-white flex flex-col">


          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Beating the bush') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer1 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Taking a long time to get to the point') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer2 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>


          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Explain the reason for your position') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer3 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Dissimulate') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer4 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Postponed dealing with a problem') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer5 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Minimized a problem or a situation') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer6 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>


          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Sending emails instead of talking in person') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer7 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Expect the other person to understand') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer8 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>



        </div>

        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 12">
        <p>
          {{ $t('They just make your life miserable') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 13">
        <p>{{ $t('Make a note of how you might manage') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 2, activate(1)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>


    <!--coraggio-->
    <div v-show="step === 14">
        <p>
         {{ $t("Take a situation that you're not dealing with or a request that you've been thinking you should do but are not doing.") }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 15">
        <p>
          {{ $t('Now we would like you to send a message or an email to that person where YOU ASK HIM/HER WHAT YOU WANT.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 16">
        <p>
          {{ $t('The message should be cordial, express your admiration or affection for the person you are sending it to, and then contain the explicit request you want to make. It should end with a cordial greeting.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 17">
        <p>
          {{ $t('Doing so will help you take the FIRST action to start changing.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 18">
        <p>{{ $t("Click OK when you've submitted it (we know you're scared 😊 )") }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next(), isComplete = true" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
  

    <div v-if="isComplete == true && done[1] == 0" class="mx-8">
      <form @submit.prevent="submit">
      <audio autoplay>
        <source src="/sound/money.wav" type="audio/wav" />
      </audio>
      <ul class="flex flex-wrap text-center justify-center">
        <li class="w-1/6">
          <img src="/img/osm-coin.png" alt="gem" />
        </li>
      </ul>
      <p class="p-8 text-center text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have finished this improvement program!!!') }}<br />
        Ti abbiamo assegnato 0.5 OSM Coin!!!
      </p>
      <button
          type="submit"
          class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
        >
          fine
        </button>
      </form>
    </div>

    <div v-if="isComplete == true && done[1] == 1" class="p-8">
      <h5 class="text-left text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have finished this improvement program!!!') }}<br />
      </h5>
      <inertia-link :href="route('curricula')" class="inline-block text-white py-2 px-6 border-2 border-white rounded-xl mt-16">
        fine
      </inertia-link>
    </div>

    
  </div>
</template>

<script>
import Button from '../../Jetstream/Button.vue';
export default {
   props: ['done'],
  components: { Button },
  data() {
    return {
      step: 1,
      progress: 0,
      isComplete: false,
      active_el: 0,
      program_id: 2,
      answer1: 0,
      answer2: 0,
      answer3: 0,
      answer4: 0,
      answer5: 0,
      answer6: 0,
      answer7: 0,
      answer8: 0,
    };
  },
  methods: {
    prev() {
      this.step--;
      var stepValue = 10;
      this.progress = this.progress - stepValue;
    },
    next(progress) {
      this.step++;
      var stepValue = 10;
      this.progress = this.progress + stepValue;
    },
    activate:function(el){
        this.active_el = el;
    },
    submit() {
      const data = new FormData()
      data.append('program_id', this.program_id)

      this.$inertia.post(this.route('workout.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
};
</script>

<style>
.done {
  background:#7ED321;
  font-weight:bold;
}

.green-bkg {
background: #36D096;
background: -webkit-linear-gradient(top right, #36D096, #1AAAAF);
background: -moz-linear-gradient(top right, #36D096, #1AAAAF);
background: linear-gradient(to bottom left, #36D096, #1AAAAF);
}

</style>